import { defineMessages } from '@cookbook/solid-intl'

// Split out of `inbox-page.messages.en.js` so the router's document-title/meta-
// description wiring doesn't have to eagerly pull that entire page's messages file
// into the boot-critical chunk just for these strings. Same pattern/rationale as
// `tos-page-routing.messages.en.js` / `privacy-page-routing.messages.en.js`
// (TENANT-5036 bundle audit).
export const messages = {
    descriptionMessage: defineMessages({
        defaultMessage: 'Manage your messages on Lodgr. View and respond to conversations with guests and hosts.',
        id: 'InboxPage.descriptionMessage',
    }),
    titleMessage: defineMessages({
        defaultMessage: 'Inbox | Lodgr',
        id: 'InboxPage.titleMessage',
    }),
}
